import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Icon } from 'ui';
import { injectIntl } from 'react-intl';

const BackToTop = styled.a`
  bottom: 0;
  margin-bottom: ${p => p.marginBottom}px;
  color: ${p => p.theme.colors.theme};

  &:hover {
    color: #49a9ee;
    & > i {
      color: #49a9ee;
    }
  }
`;

const BackTop = ({ visible, marginBottom = 15, intl }) => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) {
    return <span />;
  }
  return (
    <BackToTop onClick={scrollTop} marginBottom={marginBottom}>
      <Icon marginRight={5} type='arrow-circle-up' />
      {intl.formatMessage({ id: 'common.BACK_TO_TOP' })}
    </BackToTop>
  );
};

BackTop.propTypes = {
  visible: PropTypes.bool,
  marginBottom: PropTypes.number,
  intl: PropTypes.object,
};

export default injectIntl(BackTop);
